export const DEFAULT_ROWS_COUNT = 20;
